module.exports = __webpack_public_path__ + "static/img/app-lt.c80ee1c5.png";